import { i18n } from '@fs/zion-locale'

export default {
  editButtonText: () => i18n.t('GroupDataHeader.editButtonText', 'Edit'),
  heading: () => i18n.t('GroupDataHeader.heading', 'Image Group Data'),
  subHeading: (x, y) =>
    i18n.t('GroupDataHeader.metadataItemOfGroupTotal', 'Metadata describing Item {x} of {y}', { x, y }),
  tooltipLabel: (index, total) => i18n.t('GroupDataHeader.tooltipLabel', 'Item {index} of {total}', { index, total }),
  tooltipDescription: (itemNumber, startIndex, endIndex, initialImages) =>
    i18n.t(
      'GroupDataHeader.tooltipDescription',
      'Item {itemNumber} is a group containing images {startIndex}–{endIndex} of an image group that originally had {initialImages} images.',
      { itemNumber, startIndex, endIndex, initialImages }
    ),
  tooltipAria: () => i18n.t('GroupDataHeader.tooltipAria', 'More item information'),
  prevButton: () => i18n.t('GroupDataHeader.prevButton', 'Previous'),
  nextButton: () => i18n.t('GroupDataHeader.nextButton', 'Next'),
  wholeGroup: () => i18n.t('GroupDataHeader.wholeGroup', 'Metadata describing the entire group of images'),
  errorMessage: () =>
    i18n.t('GroupDataHeader.errorMessage', 'We encountered an unexpected error. Please try again later.'),
  recordMetadataReviewDialogBody: () =>
    i18n.t(
      'GroupHeader.recordMetadataReviewDialogBody',
      'This image group has been indexed by a computer, but the metadata must be reviewed for accuracy before the new records are published. Please carefully confirm or correct the metadata so that the records will be searchable for users.'
    ),
  recordMetadataReviewTitle: () => i18n.t('GroupHeader.recordMetadataReviewTitle', 'Record Metadata Review'),
  recordMetadataReviewModalTitle: () =>
    i18n.t('GroupHeader.recordMetadataReviewModalTitle', 'Please Review for Accuracy'),
  recordMetadataReviewBackToDashboardButton: () =>
    i18n.t('GroupHeader.recordMetadataReviewBackToDashboardButton', 'Back to Dashboard'),
  okayButton: () => i18n.t('GroupHeader.okayButton', 'Okay'),
  recordMetadataReviewDialogDoNotShowAgainCheckboxLabel: () =>
    i18n.t('GroupHeader.recordMetadataReviewDialogDoNotShowAgainCheckboxLabel', `Don't show this again`),
  finishRecordMetadataReviewBackButton: () => i18n.t('GroupDataHeader.finishRecordMetadataReviewBackButton', 'Back'),
  finishRecordMetadataReviewTitle: () =>
    i18n.t('GroupDataHeader.finishRecordMetadataReviewTitle', 'Do you want to submit the review?'),
  finishEditRecordMetadataReviewTitle: () =>
    i18n.t('GroupDataHeader.finishEditRecordMetadataReviewTitle', 'Is everything correct?'),
  finishReviewButton: () => i18n.t('GroupDataHeader.finishReviewButton', 'Yes, Submit Review'),
  finishEditReviewButton: () => i18n.t('GroupDataHeader.finishEditReviewButton', 'Yes, Save and Submit Review'),
  recordMetadataReviewEditMetadataButton: () =>
    i18n.t('GroupHeader.recordMetadataReviewEditMetadataButton', 'Edit Metadata'),
  recordMetadataReviewCheckboxInstructions: () =>
    i18n.t(
      'GroupHeader.recordMetadataReviewCheckboxInstructions',
      'This image group needs to be divided and reviewed.'
    ),
  recordMetadataReviewCheckboxLabel: () => i18n.t('recordMetadataReviewCheckboxLabel', 'Needs Organizing'),
  recordMetadataReviewIsCorrectButton: () => i18n.t('recordMetadataReviewIsCorrectButton', 'Metadata is Correct'),
  recordMetadataReviewIsCorrectSubHeading: () =>
    i18n.t(
      'recordMetadataReviewIsCorrectSubHeading',
      'Indexed records from this image group will be published and searchable when its metadata review is complete.'
    ),
  recordMetadataReviewIsCorrectHeading: () => i18n.t('recordMetadataReviewIsCorrectHeading', 'Confirm Metadata'),
  recordMetadataReviewModifySubHeading: () =>
    i18n.t(
      'recordMetadataReviewModifySubHeading',
      'Carefully correct any metadata errors so that records will be categorized properly. Editing the metadata will return the image group for reprocessing.'
    ),
  recordMetadataReviewModifyHeading: () => i18n.t('recordMetadataReviewModifyHeading', 'Modify Metadata'),
  redactImage: () => i18n.t('GroupDataHeader.redactImage', 'Redact Image'),
  selectItem: () => i18n.t('GroupDataHeader.selectItem', 'Select Item'),
  goToPreviousItem: () => i18n.t('GroupDataHeader.goToPreviousItem', 'Go to previous item'),
  goToNextItem: () => i18n.t('GroupDataHeader.goToNextItem', 'Go to next item'),
}
